<script>
import InvoicesApi from "@/services/invoices-api";
import CustomersApi from "@/services/customers-api";
import ItemsApi from "@/services/items-api";


import Swal from "sweetalert2";
import vue2Dropzone from "vue2-dropzone";

export default {
  components: { vueDropzone: vue2Dropzone},
      props: {
        selectedSupplier: {
        type: Number,
    },
    status: Number,
    customerId:Number,
      },

    mounted(){
      this.role=sessionStorage.getItem("userr");
      this.processGetInvoices();
      this.getCustomers();
      this.getMaxFileSize();
    },
    data (){
        return {
            showModal: false,
            role:null,
            invoicesList:[],
            showForm:false,
            selectedInvoice:{id:null,title:'',name:'',date:'',withholding:'', customer:null,total:'',type:'0',invoiceNumber:''},
            selectedPDF:null,
            selectedWithholding:null,
            formData:null,
            selectedCustomer:null,
            customerList:[],
            pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
            isTableBusy:false,
            
            dropzoneOptions: {
              url: "/",
              thumbnailWidth: 150,
              // maxFileSizeInMB: 1,
              addRemoveLinks: true,
              autoProcessQueue:false,
            },

            maxFileSize: null,
            formError:false,



        }
    },
    methods: {

    processGetInvoices(){
      const type = this.$route.query.type
      type !== undefined ? Number(type) : null

      if(type != null){
        this.getInvoices(type);
      }else{
        this.getInvoices();
      }

    },

    getMaxFileSize(){
        ItemsApi.getMaxFileSize().then(
            size => {
                this.maxFileSize=size;
            })
    },
    getCustomers(){
      CustomersApi.getCustomers().then(
        result =>{
          this.customerList=result;
        }
      )
    },
    getInvoices(pathStatus) {
      this.isTableBusy = true;
      InvoicesApi.getInvoices(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedSupplier,this.customerId, pathStatus != null ? pathStatus : this.status)
        .then(result => {
          this.invoicesList = result.list
          this.pagemodelMain.totalRows = result.total;
          this.pagemodelMain.currentPage = result.page;
          this.pagemodelMain.perPage = result.pageSize;
          this.pagemodelMain.pageSize = result.pageSize;
        })
        .finally(() => {
        this.isTableBusy = false;
      })
    },

    addNewInvoice(){
      this.selectedInvoice={id:null,title:'',name:'',deadlines:[],date:'',withholding:'', customer:null,total:'',type:'0',invoiceNumber:''};
      this.showModal=true;
      this.formError=false
    },

    saveInvoice(){
      this.formError=false
      this.selectedPDF=this.$refs.myVueDropzone.getAcceptedFiles()[0]
      if(!this.selectedPDF  || !this.selectedInvoice.customer || !this.selectedInvoice.customer.id || !this.selectedInvoice.date || !this.selectedInvoice.total || !this.selectedInvoice.invoiceNumber) {        this.formError=true
        return;
      }
      this.selectedInvoice.total=  this.selectedInvoice.total.toString().split(',').join('.')
      Swal.fire({
        title: "Ajouter cette facture",
        html:this.selectedInvoice.invoiceNumber,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, enregistrer!"
    }).then(result=>{
      if(result.value){
          const fd = new FormData();
          fd.set('file',this.selectedPDF)
          fd.set('name',this.selectedInvoice.invoiceNumber)
          fd.set('customerId',this.selectedInvoice.customer.id)
          fd.set('date',this.selectedInvoice.date)
          fd.set('total', this.selectedInvoice.total)
          fd.set('type',this.selectedInvoice.type)
          fd.set('invoiceNumber',this.selectedInvoice.invoiceNumber)
          InvoicesApi.saveInvoice(fd).then(
          (result)=>{
            if(result){
              this.getInvoices()
              this.selectedInvoice={id:null,title:'',name:'',deadlines:[],formattedDate:'',withholding:'', customer:null,invoiceNumber:''};
              this.showModal=false
              this.selectedPDF=null
            }
          }
      )}}
        )
    },

    editInvoice(){
      this.formError=false
      if(!this.selectedInvoice.customer || !this.selectedInvoice.customer.id || !this.selectedInvoice.date || !this.selectedInvoice.total || !this.selectedInvoice.invoiceNumber) {        this.formError=true
        return;
      }
      this.selectedInvoice.total=  this.selectedInvoice.total.toString().split(',').join('.')
        Swal.fire({
        title:"Enregistrer les modification apportée à cette facture ?",
        html: this.selectedInvoice.invoiceNumber,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, enregistrer!"
    }).then(result=>{
      if(result.value){
        InvoicesApi.editInvoice(this.selectedInvoice).then(
          (result)=>{
            if(result){
              this.getInvoices()
              this.selectedInvoice={id:null,title:'',name:'',deadlines:[],formattedDate:'',withholding:'', customer:null,invoiceNumber:''};
              this.showModal=false
            }

          }
        )
      }
    })
    },

    onPDFUploadInvoice(id){
      if(!this.selectedPDF) {
          return;
      }
      const fd = new FormData();
      fd.append('file', this.selectedPDF, this.selectedPDF.name)
      InvoicesApi.saveInvoiceFilePDF(fd,id).then(
          () =>{
                this.getInvoices();

                }
      ).finally(
          this.selectedPDF=null
      )
    },

    onPDFUploadWithholing(id){
        if(!this.selectedWithholding) {
          return;
      }
      const fd = new FormData();
      fd.append('file', this.selectedWithholding, this.selectedWithholding.name)
      InvoicesApi.saveWithholdingFilePDF(fd,id).then(
        ()=>{
          this.getInvoices();
        }
      ).finally(
        this.selectedWithholding=null
      )
    },

    deleteWithholdingFile(id){
      Swal.fire({
        title: "Supprimer la retenue à la source ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
    }).then(result=>{
      if(result.value){
        InvoicesApi.deleteWithholdingFile(id).then(
          ()=>{
            this.getInvoices();
          }
        )
      }
    }
      )
    },

    deleteInvoice(invoice){
      Swal.fire({
        title: "Supprimer la facture ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
    }).then(result=>{
      if(result.value){
        InvoicesApi.deleteInvoice(invoice.id).then(
          ()=>{
            this.getInvoices();
          }
        )
      }
    }
      )
    },

    downloadFile(title){
      InvoicesApi.downloadFile(title)
    },

    showInvoiceModal(invoice){
      this.selectedInvoice.id=invoice.id;
      this.selectedInvoice.name=invoice.invoiceNumber;
      this.selectedInvoice.date=invoice.date;
      this.selectedInvoice.customer=invoice.customer;
      this.selectedInvoice.total=invoice.total;
      this.selectedInvoice.type=invoice.type;
      this.selectedInvoice.invoiceNumber=invoice.invoiceNumber;
      this.showModal=true;
      this.formError=false
      this.alphaNumericError=false
      this.numericError=false;
    },

    downloadWithHolding(invoiceId){
      InvoicesApi.downloadWithHolding(invoiceId).then(
        (response)=>{
          if(response){
            InvoicesApi.getWithHolding(invoiceId)
          }
        }
      )
    }

    },
      watch: {
    selectedSupplier : function(){
      this.getInvoices()
    },

    status : function(){
      this.getInvoices()
    },
    
    customerId: function(){
      this.getInvoices()
    },

      }
};
</script>
<template>
<div>
  <div v-if="role==1" class="row">
    <div class="col-sm-10 col-md-6"></div>
    <div class="col-sm-2 col-md-6 text-right mb-3 mt-1" >
      <b-button variant="primary" @click="addNewInvoice()">
        <i class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2"></i> <span class=" font-weight-bold">Nouvelle Facture</span>
      </b-button>
    </div>
  </div>
  <div class="table-responsive mb-0">
  <table class="table table-centered table-nowrap">
      <thead class="thead-light">
          <tr>
              <th>Echeance </th>
              <th>Facture</th>
              <th class="text-left">Retenue à la source</th>
              <th v-if="role==0 || role==2 " >Fournisseur</th>
              <th v-if="role==1 || role==2 " >Client</th>
              <th class="text-left">Date de création</th>
              <th class="text-right">Total</th>
              <th class="text-right">Net après RS</th>
              <th>Etat </th>
              <th v-if="role==1"></th>

          </tr>
      </thead>
      <tbody>
          <tr v-for="(invoice) in this.invoicesList" :key="invoice.id" >
            <td>{{invoice.formattedDate}}</td>

            <td>
              <label v-if="role==1"  :for="String(invoice.id)+'invoice' " class="css-class">
                <i v-b-tooltip.hover title="Uploader la fature" class="fas fa-upload text-primary font-size-16 mr-3" style="cursor:pointer"></i>
                <b-form-file v-model="selectedPDF"  :id="String(invoice.id)+'invoice' "  @input="onPDFUploadInvoice(invoice.id)" style="display:none"></b-form-file>
        
            </label>
              <a v-bind:style="[invoice.title ? {'visibility':'visible'} :{'visibility':'hidden'}]"  @click.prevent="downloadFile(invoice.title)" 
              class="action-icon font-size-12 font-weight-bold text-primary mr-3" title="Télécharger la facture" style="cursor:pointer">
                {{invoice.invoiceNumber==null ? invoice.name : invoice.invoiceNumber }}
              </a>

            </td>

            <td class="text-left">
                <!-- <label v-if="role==0"  :for="String(invoice.id)+'withholding'" class="css-class">
                    <i v-b-tooltip.hover title="Uploader la retenue à la source" class="fas fa-upload text-primary font-size-16 mr-2" style="cursor:pointer"></i>
                    <b-form-file v-model="selectedWithholding"  :id="String(invoice.id)+'withholding'"  @input="onPDFUploadWithholing(invoice.id)" style="display:none"></b-form-file>
                </label>
                <a v-if="role==0" v-bind:style="[invoice.withholding ? {'visibility':'visible'} :{'display':'none'}]"  @click="deleteWithholdingFile(invoice.id)" href="javascript:void(0);" class="action-icon font-size-16 text-primary mr-3"><i v-b-tooltip.hover title="Supprimer la retenue à la source" class="fas fa-times text-danger"></i></a>
              <a v-bind:style="[invoice.withholding ? {'visibility':'visible'} :{'display':'none'}]"  @click.prevent="downloadFile(invoice.withholding)" 
              class="action-icon font-size-12 text-primary mr-3" title="Télécharger la retenue"  style="cursor:pointer">
              retenue à la source
              </a> -->

                 <a  title="modifier" href="javascript:void(0);"  @click="downloadWithHolding(invoice.id)" v-bind:style="[invoice.total>=1000.0 ? {'visibility':'visible'} :{'display':'none'}] "  class="action-icon text-primary pr-2" >
                  <span class="font-size-14" title="Générer la retenue à la source"><i class="fas fa-file-signature font-size-18 pr-1"  /> Générer</span>
                </a>
            </td>

            <td v-if="role==0 || role==2">
              {{invoice.supplier.name}}
            </td>
            <td v-if="role==1 || role==2">
              {{invoice.customer.name}}
            </td>

            <td>
              {{invoice.creationDate}}
            </td>

            <td class="text-right">
              {{invoice.totalAsString}}
            </td>

            <td class="text-right">
              {{invoice.totalAfterWithHolding}}
            </td>

            <td>
                <span
                  :class="invoice.type==0 ? 'badge badge-pill badge-soft-danger font-size-12' :'badge badge-pill badge-soft-success font-size-12'" 
                >{{invoice.type==0 ? 'Impayé' : 'Payé'}}</span>
            </td>

            <td v-if="role==1">

              <a  title="modifier" href="javascript:void(0);"  @click="showInvoiceModal(invoice)" class="action-icon text-warning pr-2" >
                  <i class="mdi mdi-pencil font-size-22"  />
              </a>
              <a  title="supprimer" href="javascript:void(0);"  @click="deleteInvoice(invoice)" class="action-icon text-danger " >
                  <i class="mdi mdi-trash-can font-size-22 " />
              </a>
            </td>
          </tr>
      </tbody>
  </table>
  <span v-if="!isTableBusy && !invoicesList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune facture dans la liste</span>

  <!-- Pagination -->
  <div class="row pt-3 mb-sm-4">
      <div class="col-sm-8">
          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
              <b-form-select @input="getInvoices()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
          </div>
      </div>
      <div class="col-sm-4">
          <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="pagemodelMain.currentPage" :disabled="isTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getInvoices()" ></b-pagination>
              </ul>
          </div>
      </div>
  </div> 
  <!-- Fin Pagination  -->
      <b-modal v-model="showModal" 
      v-if="this.role==1"
      :hide-footer="this.role==0"
      title="Details de la facture" 
      centered 
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl">
        <div class=" zoom-container">

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >Client</label>
          <div class="col-md-9">
            <v-select class="style-vselect" :options="customerList" v-model="selectedInvoice.customer" :clearable="false" placeholder="" label="name" >
                <span slot="no-options">Aucun élément dans la liste</span>
            </v-select> 
          </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >Facture N°</label>
          <div class="col-md-9">
            <input v-model="selectedInvoice.invoiceNumber" type="text"  class="form-control"  />
          </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >Echeance</label>
            <div class="col-md-9">
              <b-form-datepicker
                v-model="selectedInvoice.date"
                right
                locale="fr"
                label-no-date-selected="Date Echeance"
                dark
              ></b-form-datepicker>
            </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" for="name">Montant</label>
          <div class="col-md-9">

              <input v-model="selectedInvoice.total" type="text" class="form-control"  />
          </div>
        </div>  

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" for="name">Etat</label>
          <div class="col-md-4 custom-control custom-radio  mt-2 m-0 p-0 text-secondary">
            <b-form-radio v-model="selectedInvoice.type"  value="0">Impayé</b-form-radio>
          </div>
          <div class="col-md-5 custom-control custom-radio  mt-2 m-0 p-0  text-primary">
            <b-form-radio v-model="selectedInvoice.type"  value="1">Payé</b-form-radio>
          </div>
        </div> 

        <div v-if="!this.selectedInvoice.id" class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >Fichier (PDF)</label>
          <div class="col-md-9">
            <vue-dropzone
              id="dropzone"
              ref="myVueDropzone"
              maxFileSizeInMB="1"
              maxNumberOfFiles="1"
              :use-custom-slot="true"
              :options="dropzoneOptions"
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>Déposez les fichiers ici ou cliquez pour uploader.</h4>
              </div>
            </vue-dropzone>
          </div>
        </div>

        <div   class="row mb-3 ml-4">
          <div class="col-md-3"/>
          <div class="col-md-9">
            <span v-if="formError" class="text-danger font-size-10 font-italic" >Tous les champs sont obligatoires</span> 
          </div>
        </div>

        <div v-if="!this.selectedInvoice.id" class="row">
          <div class="col-md-3"/>
          <div class="col-md-9">
            <b-alert show variant="warning" class="text-justify ml-3">
                <i class="mdi mdi-alert-outline mr-2"></i>La taille de fichier ne doit pas dépasser <span class="font-weight-bold" > {{this.maxFileSize}}</span>. 
                Le seul type supporté est <span class="font-weight-bold"> PDF </span>. 
                <br>
                Le nombre <span class="font-weight-bold"> maximal </span> de fichier accepté est  <span class="font-weight-bold"> 1 </span>.
            </b-alert>
          </div>
        </div>

        


      </div>
        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary" @click="showModal = false" size="md">Annuler</b-button>
          <b-button class="zoom-container" variant="primary" @click="selectedInvoice.id ? editInvoice() : saveInvoice()" size="md" >Enregistrer</b-button>
        </template>
      </b-modal>

  </div>
</div>
</template>